import { useTranslation } from 'react-i18next';

export const FooterRightBlock: React.FC = () => {
  const { t } = useTranslation();
  const footerInformations = t('footer.informations', {
    returnObjects: true,
  }) as string[];

  return (
    <div>
      {footerInformations.map((information: string) => (
        <p key={information} className="c-footer__paragraph">
          {information}
        </p>
      ))}
    </div>
  );
};
